import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const SystemUpdateSettings = () => (
  <ImageIcon src={Images.SystemUpdateSettings} alt="System Update Settings" />
);

export default SystemUpdateSettings;
